import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "iframe"]

  connect() {
    // Create modal element if it doesn't exist
    if (!document.getElementById('youtubeVideoModal')) {
      this.createModalElement()
    }
  }

  createModalElement() {
    const modalHtml = `
      <div class="modal fade" id="youtubeVideoModal" tabindex="-1" aria-labelledby="youtubeVideoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="youtubeVideoModalLabel">Video</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-0">
              <div class="ratio ratio-16x9">
                <iframe data-video-modal-target="iframe" src="" title="YouTube video" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    `
    document.body.insertAdjacentHTML('beforeend', modalHtml)
  }

  openVideo(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const youtubeUrl = button.dataset.youtubeUrl
    
    if (youtubeUrl) {
      // Convert standard YouTube URL to embed URL with autoplay
      const videoId = this.getYoutubeVideoId(youtubeUrl)
      const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`
      
      // Get modal instance and iframe
      const modal = document.getElementById('youtubeVideoModal')
      const iframe = modal.querySelector('iframe')
      
      // Set iframe src
      iframe.src = embedUrl
      
      // Initialize and show modal
      const modalInstance = new bootstrap.Modal(modal)
      modalInstance.show()
      
      // Reset iframe when modal is hidden
      modal.addEventListener('hidden.bs.modal', () => {
        iframe.src = ''
      }, { once: true })
    }
  }
  
  getYoutubeVideoId(url) {
    // Extract video ID from various YouTube URL formats
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
    const match = url.match(regExp)
    return (match && match[2].length === 11) ? match[2] : null
  }
}